import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { EsService } from '../../services/es.service';
import { ToastComponent } from '../toast/toast.component';
import { Sentiment } from '../types';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
  standalone: false
})
export class ResultComponent implements OnInit {
  private router = inject(Router);
  private esService = inject(EsService);
  toast = inject(ToastComponent);


  @Input() results = [];
  @Input() isLoading: boolean;

  isStakeholdersPage = false;
  isLoadingSentiment = false;

  ngOnInit(): void {
    if (this.router.url.includes('stakeholder/')) {
      this.isStakeholdersPage = true;
    }
  }

  updateSentiment(id: string, sentiment: Sentiment): void {
    this.isLoadingSentiment = true;
    this.esService.updateSentiment(id, sentiment)
      .subscribe({
        next: res => this.toast.setMessage('Sentiment updated successfully!', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
        complete: () => this.isLoadingSentiment = false
      });
  }

  deleteItem(id: string): void {
    if (window.confirm('Are you sure you want to delete this item?')) {
      this.esService.delete(id)
        .subscribe({
          next: res => this.toast.setMessage('Item deleted successfully!', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger')
        });
    }
  }

}
